<template>
  <div>
    <v-card>
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab>Altas</v-tab>
        <v-tab>Bajas</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card-title>
            Historial de Altas
            <v-spacer></v-spacer>
            <v-btn class="ma-2" color="green" fab small dark @click="_nuevo()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <Listado :datos="datos" :encabezados="encabezados" :acciones="acciones"></Listado>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-title>
            Historial de Bajas
            <v-spacer></v-spacer>
            <v-btn color="orange" fab small dark @click="_baja()">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <Listado :datos="datosBajas" :encabezados="encabezadosBajas" :acciones="accionesBajas"></Listado>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import Listado from "@/components/Listado.vue";
export default {
  name: "Clientes_Listado",
  components: {
    Listado,
  },
  data() {
    return {
      tab: 0,
      datos: "/mercaderias",
      encabezados: [
        {
          text: "Fecha y Hora",
          align: "start",
          value: "fechaAlta",
        },
        { text: "Proveedor", value: "proveedor.nombre" },
        { text: "Tipo de Comprobante", value: "comprobante.tipo" },
        { text: "Numero de Comprobante", value: "comprobante.numero" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      acciones: {
        ver: "/mercaderias/",
      },
      datosBajas: "/mercaderias/bajas",
      encabezadosBajas: [
        {
          text: "Fecha y Hora",
          align: "start",
          value: "fechaAlta",
        },
        { text: "Motivo", value: "motivo" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      accionesBajas: {
        ver: "/mercaderias/baja/",
      },
    };
  },
  methods: {
    _nuevo() {
      this.$router.push(`/mercaderias/nuevo`);
    },
    _baja() {
      this.$router.push(`/mercaderias/baja`);
    },
  },
};
</script>
